/* Liberty Loan Network — theme.js
   Motion engine: word splitting for blur-focus reveals, IntersectionObserver
   wipes, card-fan and timeline triggers, header shrink, mobile nav, FAQ.
   No libraries. Everything degrades to static visible content without JS,
   and prefers-reduced-motion skips all class choreography. */

(function () {
  "use strict";

  document.documentElement.classList.add("js");

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Blur-focus word splitter ---------- */

  function splitFocusHeadings() {
    var headings = document.querySelectorAll("[data-focus]:not([data-split])");
    Array.prototype.forEach.call(headings, function (heading) {
      var wordIndex = 0;

      function splitNode(node) {
        if (node.nodeType === 3) {
          var words = node.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          words.forEach(function (word) {
            if (word.trim() === "") {
              frag.appendChild(document.createTextNode(word));
              return;
            }
            var span = document.createElement("span");
            span.className = "fw";
            span.style.setProperty("--i", String(wordIndex));
            span.textContent = word;
            frag.appendChild(span);
            wordIndex += 1;
          });
          node.parentNode.replaceChild(frag, node);
        } else if (node.nodeType === 1 && !node.classList.contains("fw")) {
          Array.prototype.slice.call(node.childNodes).forEach(splitNode);
        }
      }

      Array.prototype.slice.call(heading.childNodes).forEach(splitNode);
      heading.setAttribute("data-split", "done");
    });
  }

  /* ---------- IntersectionObserver reveals ---------- */

  function initReveals() {
    var targets = document.querySelectorAll(
      ".reveal, [data-split], [data-fan] .fan, [data-timeline]"
    );

    if (reduceMotion || !("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.08 }
    );

    Array.prototype.forEach.call(targets, function (el) {
      io.observe(el);
    });

    /* Timeline items also reveal individually so nodes fill in sequence */
    var timelineItems = document.querySelectorAll("[data-timeline] .timeline__item");
    Array.prototype.forEach.call(timelineItems, function (el) {
      io.observe(el);
    });
  }

  /* Above-the-fold headings fire on load rather than on scroll */
  function triggerLoadFocus() {
    var loadTargets = document.querySelectorAll("[data-focus-load]");
    Array.prototype.forEach.call(loadTargets, function (el) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          el.classList.add("is-visible");
        });
      });
    });
  }

  /* ---------- Header shrink ---------- */

  function initHeaderShrink() {
    var header = document.querySelector("[data-header]");
    if (!header) return;

    var ticking = false;

    function update() {
      header.classList.toggle("is-shrunk", window.scrollY > 40);
      ticking = false;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  /* ---------- Mobile nav ---------- */

  function initMobileNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var panel = document.querySelector("[data-mobile-nav]");
    if (!toggle || !panel) return;

    toggle.addEventListener("click", function () {
      var open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", open ? "false" : "true");
      toggle.classList.toggle("is-active", !open);
      panel.style.maxHeight = open ? "0px" : panel.scrollHeight + "px";
    });
  }

  /* ---------- FAQ accordion ---------- */

  function initFaq() {
    var toggles = document.querySelectorAll("[data-faq-toggle]");
    Array.prototype.forEach.call(toggles, function (btn) {
      btn.addEventListener("click", function () {
        var open = btn.getAttribute("aria-expanded") === "true";
        var answer = btn.parentElement.querySelector("[data-faq-answer]");
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        if (answer) {
          answer.classList.toggle("is-open", !open);
        }
      });
    });
  }

  /* ---------- Boot ---------- */

  function init() {
    splitFocusHeadings();
    initReveals();
    triggerLoadFocus();
    initHeaderShrink();
    initMobileNav();
    initFaq();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
